import styled from 'styled-components';
export var StyledViewMore = styled.span.withConfig({
  displayName: "partials__StyledViewMore",
  componentId: "sc-1617v0q-0"
})(["cursor:pointer;font-weight:700;color:", ";svg{vertical-align:sub;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
export var Description = styled.div.withConfig({
  displayName: "partials__Description",
  componentId: "sc-1617v0q-1"
})(["display:flex;flex-direction:column;justify-content:flex-start;margin-left:30px;"]);